module.exports = __webpack_public_path__ + "94000ba0907b7611e3e4bf7ced5e1897.svg";